import React from 'react';
import { css } from 'styled-components';

import PropTypes from 'prop-types';
import Header from './header';
import Footer from './footer';
import NormalizeStyle from '../base/Normalize';
import ScrollToTop from '../components/basic/ScrollToTop';
import useTheme from '../utils/styles/theme/useTheme';

const BaseLayout = props => {
  const { colors } = useTheme();
  const { headerType, blank, children, headerProps = {} } = props;
  let backgroundColor = 'transparent';
  if (headerType === 'red') {
    backgroundColor = colors.primary.light;
  } else if (headerType === 'grey') {
    backgroundColor = colors.gray.light;
  }
  return (
    <React.Fragment>
      <NormalizeStyle />
      <div
        css={css`
          background-color: ${backgroundColor};
        `}
      >
        {!blank && <Header headerType={headerType} {...headerProps} />}
        {children}
        {!blank && <Footer />}
      </div>
      <ScrollToTop />
    </React.Fragment>
  );
};

BaseLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  headerType: PropTypes.oneOf(['red', 'grey']),
  blank: PropTypes.bool,
  headerProps: PropTypes.shape({})
};

BaseLayout.defaultProps = {
  headerType: null,
  blank: false,
  headerProps: {}
};

export default BaseLayout;
